<template>
  <span class="quoteActionsButtonWrapper">
    <app-button
      :data-qa="`${formattedType}-download-pdf-button`"
      :button-class="isDisabled ? '' : buttonClass"
      type="button"
      class="quoteActionsButton"
      :disabled="isDisabled"
      @click="customerTypeCheck() && download()"
    >
      {{ title }}
      <loader v-if="isLoading" />
    </app-button>
    <customer-type-prompt
      :show="showCustomerTypePrompt"
      @confirm="download"
      @close="showCustomerTypePrompt = false"
    />
  </span>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import { EventBus } from '@/plugins/event-bus'
import Pdf from '@/api/server/Pdf.api'
import { saveAs } from 'file-saver'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import CheckCustomerType from '@/mixins/checkCustomerType.js'
import CustomerTypePrompt from '@/components/generic/presentational/molecules/customerTypePrompt/CustomerTypePrompt.vue'
import AdditionalOrder from '@/mixins/additionalOrder.js'

export default {
  components: {
    Loader,
    AppButton,
    CustomerTypePrompt,
  },
  mixins: [AdditionalOrder, CheckCustomerType],
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    quoteId: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: 'inverted--bordered',
    },
  },
  data() {
    return {
      isLoading: false,
      pdfFactory: [
        { type: 'OFFER_PDF', download: Pdf.GetOfferPdf },
        { type: 'ORDER_PDF', download: Pdf.GetOrderPdf },
        { type: 'CONCEPT_PDF', download: Pdf.GetConceptPdf },
      ],
    }
  },
  computed: {
    isDisabled() {
      return this.isLoading || !this.quoteId || this.disabled
    },
    formattedType() {
      return this.type.toLowerCase().replace('_', '-')
    },
  },
  methods: {
    async download() {
      this.isLoading = true

      await this.$store.dispatch(`${this.quoteNamespace}/createOrUpdate`)

      try {
        const download = this.pdfFactoryCreate()
        const data = await download(this.quoteId)

        saveAs(data.pdfContent, data.fileName)
      } catch (e) {
        EventBus.$emit('notification-warning', 'Niet gelukt om de Pdf te downloaden')
      } finally {
        this.isLoading = false
      }
    },
    pdfFactoryCreate() {
      return this.pdfFactory.find((f) => f.type === this.type).download
    },
  },
}
</script>
